import { ELECTION_ATTRIBUTE_NUMBERS } from '~/consts/elections';
import { getStore } from '~/mobx/AppStore';

export const onInputChange = (key: string, value: string) => {
    const { adminStore } = getStore();

    const updatedAttributes = adminStore.attributesState?.map((attr) => {
        if (attr.number !== key) return attr;

        // Clone and update selected attribute
        const updatedAttr = { ...attr };

        if (attr.type === 'single_select') {
            // For single_select, find the selected option by valueId
            const selectedOption = attr.options?.find((opt) => opt.valueId === value);
            updatedAttr.value = selectedOption?.valueId || '';
        } else if (attr.number === ELECTION_ATTRIBUTE_NUMBERS.election_next_year) {
            const newValue: number = parseInt(value.slice(0, 4).replace(/\D/g, ''), 10);
            updatedAttr.value = newValue > 0 ? newValue.toString() : '';
        } else {
            updatedAttr.value = value;
        }

        return updatedAttr;
    });

    adminStore.setAttributesState(updatedAttributes || []);

    // Clear validation error for this field when user starts typing
    if (adminStore.shouldShowValidationErrors && adminStore.validationErrors[key]) {
        const updatedErrors = { ...adminStore.validationErrors };
        delete updatedErrors[key];
        adminStore.setValidationErrors(updatedErrors);
    }
};
